<template>
  <div class="detail-container">
    <div class="header">
      <img id="logo" class="logo" :src="getLogoPath" alt="Logo" />
    </div>
    <div class="clothes-sign">
      <table>
        <tr v-if="!['hk'].includes(this.$route.query.loc)">
          <td>{{ $t('stock.brand') }}</td>
          <td>{{ details.brand }}</td>
        </tr>
        <tr>
          <td>{{ $t('stock.code') }}</td>
          <td>{{ details.productCode }}</td>
        </tr>
        <tr>
          <td>{{ $t('stock.inventory') }}</td>
          <td>{{ details.quantity }}</td>
        </tr>
        <tr>
          <td>{{ $t('stock.replenishment') }}</td>
          <td>{{ details.docDueDate }}</td>
        </tr>
        <tr>
          <td>{{ $t('stock.yarn') }}</td>
          <td>{{ details.yarn }}</td>
        </tr>
        <tr>
          <td>{{ $t('stock.component') }}</td>
          <td>{{ details.component }}</td>
        </tr>
        <tr>
          <td>{{ $t('stock.weight') }}</td>
          <td>{{ details.weight }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import { getStockList } from '@/api/module/stock';

export default {
  data() {
    return {
      details: {
        brand: '',
        quantity: '',
        productCode: '',
        docDueDate: '',
        yarn: '',
        component: '',
        weight: ''
      },
      currentPage: 1,
      pageSize: 10,
      total: 0,
      productNo: '',
      // logo: ['cn'].includes(process.env.VUE_APP_LANG) ? 'https://wechat.vitalitytex.com.cn/public/wap/image/logo.png' : 'https://wechat.vitalitytex.com.cn/public/wap/image/logo.png'
    };
  },
  computed: {
    getLogoPath() {
      // 返回图片的完整路径
      let image = ['cn'].includes(process.env.VUE_APP_LANG) ? 'logo_ylw.png' : 'logo_vmb.png';
      return `/images/${image}`;
    },
  },
  async created() {
    if ((this.$route.query.lang && ['cn'].includes(this.$route.query.lang))) {
      this.$i18n.locale = 'zh';
      localStorage.setItem('lang', 'zh');
    } else {
      this.$i18n.locale = 'en';
      localStorage.setItem('lang', 'en');
    }
    if (this.$route.query.code) {
      this.productNo = this.$route.query.code;
    }
    await this.fetchInventory();
  },
  methods: {
    async fetchInventory() {
      let res = await getStockList(this.currentPage, this.pageSize, {
        codebars: this.productNo, // 产品号
        stockStatus: 0,
        // language: ['zh'].includes(this.$i18n.locale) ? 'China' : 'English', // 语言
        language: ['cn'].includes(process.env.VUE_APP_LANG) ? 'China' : 'English', // 语言
      });
      if (res.code === '0' && res.data.records.length > 0) {
        this.total = res.data.total;
        this.details = {...res.data.records[0], productCode: res.data.records[0].codebars, quantity: res.data.records[0].quantity.includes('over') ? res.data.records[0].quantity.replace(/over/, 'm+') : (res.data.records[0].quantity === 'endOfSale' ? '0' : `${res.data.records[0].quantity}m`) };
      }
    },
  }
};
</script>

<style scoped>
.detail-container {
  min-height: 100vh;
  background-color: #fff;
  /* font-family: Arial, sans-serif; */
  font-family: sans-serif;
}

.header {
  /* display: flex;
  justify-content: center; */
  padding: 15px 0;
  position: fixed;
  top: 0;
  width: 100%;
  background-color: #fff;
  box-sizing: border-box;
  z-index: 100;
  border-bottom: 1px solid #e1e1e1;
}

.logo {
  display: block;
  /* height: 40px; */
  height: 37px;
  margin-left: 20px;
}

.clothes-sign {
  /* margin: 20px 10%; */
  padding-top: 108px;
}

table {
  width: 100%;
  margin-left: 10%;
  line-height: 45px;
  font-size: 18px;
}

table tr > td:first-child {
  color: #c8c8c8;
  font-weight: 300;
  width: 150px;
}

table tr > td:nth-child(2) {
  color: #000;
  font-style: normal;
  font-weight: 300;
  letter-spacing: 2px;
}
</style>
